import enCompanyFeedSettings from './en';
import ruCompanyFeedSettings from './ru';

export default {
  en: {
    ...enCompanyFeedSettings,
  },
  ru: {
    ...ruCompanyFeedSettings,
  },
};
